// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const limeHeap = defineModel({
  id: "lime-heap",
  batchId: "future",
  name: "Lime heap",
  tags: ["scenery","lime","heap","low-poly","age-of-mcp","future"],
  summary: "Burnt lime — binds mortar, fluxes smelting, whitewashes and treats soil.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.4,
  parts: () => [
      { geometry: new THREE.ConeGeometry(0.34, 0.3, 8), color: "#e9e6dc", position: [0, 0.15, 0] },
      { geometry: new THREE.ConeGeometry(0.16, 0.14, 8), color: "#f4f2ea", position: [0.02, 0.22, -0.02] },
      { geometry: new THREE.BoxGeometry(0.5, 0.08, 0.04), color: "#7a5a36", position: [0, 0.04, 0.3], rotation: [0.08, 0, 0] },
      { geometry: new THREE.BoxGeometry(0.04, 0.08, 0.46), color: "#6b4e2e", position: [0.27, 0.04, 0.06], rotation: [0, 0, 0.08] },
    ],
  animations: [],
});
